var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1333 7.86291L7.19327 8.80291C6.67327 9.32291 6.67327 10.1696 7.19327 10.6896C7.71327 11.2096 8.55995 11.2096 9.07995 10.6896L10.56 9.20959C11.6 8.16959 11.6 6.48292 10.56 5.43625C9.51997 4.39625 7.83328 4.39625 6.78662 5.43625L5.1733 7.04957C4.27996 7.94291 4.27996 9.38958 5.1733 10.2829",
    stroke: "#C1C5D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 14.6693C11.6819 14.6693 14.6667 11.6845 14.6667 8.0026C14.6667 4.32071 11.6819 1.33594 8.00004 1.33594C4.31814 1.33594 1.33337 4.32071 1.33337 8.0026C1.33337 11.6845 4.31814 14.6693 8.00004 14.6693Z",
    stroke: "#C1C5D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMention);
export default __webpack_public_path__ + "static/media/mention.7bde8ee8a087a17796eb5672a4c2934f.svg";
export { ForwardRef as ReactComponent };